export default __webpack_public_path__ + "dessert.d05914e9.svg";